import { render, staticRenderFns } from "./appointmentProperty.vue?vue&type=template&id=1bcd8860&scoped=true"
import script from "./appointmentProperty.vue?vue&type=script&lang=js"
export * from "./appointmentProperty.vue?vue&type=script&lang=js"
import style0 from "./appointmentProperty.vue?vue&type=style&index=0&id=1bcd8860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd8860",
  null
  
)

export default component.exports